import React from "react";
import {
    Row,
    Col,
    Steps,
    Button,
    Input,
    Space,
    Table,
    message
} from 'antd';
import { Map, Marker, InfoWindow } from 'google-maps-react';
import { getStoreList_map, getTrackviewAll } from "./service";
import moment from 'moment';
import Highlighter from 'react-highlight-words';

import {
    SearchOutlined,
} from '@ant-design/icons';


const google = window.google
const mapStyles = {
    width: '100%',
    height: '100%',
    // position: 'relative',
    // overflow: 'hidden',
    padding: '30px'
};

const dateFormat = 'YYYY-MM-DD';

class ViewLocation extends React.Component {
    state = {
        markers: [],
        // empCd: this.props.location.saleDetail.empCd,
        // empCd: '900001',
        date: moment().format(dateFormat),
        dateString: null,
        data: [],
        datasale: [],
        datasaleclick: [],
        myMap: null,
        showingInfoWindow: false,
        activeMarker: {},
        shopSearch: [],
        loading: true,
        current: 1,
        pageSize: 10,
        lat: 13.7278956,
        lng: 100.5241235
    };

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        getTrackviewAll()
            .then(res => {
                if (res && res.status === 200) {
                    this.setState({
                        datasale: res.data.info,
                        // loading: true,
                    })
                }
            })
        getStoreList_map()
            .then(res => {
                if (res && res.status === 200) {
                    this.setState({
                        data: res.data.info,
                        shopSearch: res.data.info,
                    })
                }
            })
    }

    dd = () => {
        console.log("this.state", this.state)
    }

    showMarkers = () => {
        var a = this.state.datasale.map((sale, index) => {
            return <Marker
                key={index}
                id={index}
                position={{
                    lat: sale.lat,
                    lng: sale.lon
                }}
                valuename={sale.firstName_th + ' ' + sale.lastName_th}
                valuesaleAreaDesc={sale.saleAreaDesc}
                valueamphur={sale.amphur}
                valueprovince={sale.province}
                valuedate={sale.log_at}
                onClick={this.onMarkerClick}
            />
        })
        return a


    }

    showMarkersclick() {
        var a = this.state.datasaleclick.map((sale, index) => {

            return <Marker
                key={index}
                id={index}
                position={{
                    lat: sale.lat,
                    lng: sale.lon
                }}
                valuename={sale.firstName_th + ' ' + sale.lastName_th}
                valuesaleAreaDesc={sale.saleAreaDesc}
                valueamphur={sale.amphur}
                valueprovince={sale.province}
                valuedate={sale.log_at}
                onClick={this.onMarkerClick}
            />
        })

        return a
    }

    onMarkerClick = (props, marker) => {
        this.setState({
            activeMarker: marker,
            showingInfoWindow: true,
            datasaleclick: [],
        });
    };

    onInfoWindowClose = () => {
        this.setState({
            activeMarker: null,
            showingInfoWindow: false
        });
    }


    temp_shop = (e) => {
        var value = e.target.value
        this.shopSearchResult(value)
    }

    shopSearchResult = (value) => {

        let data = this.state.data
        var newData = []
        data.filter(data => data.store_name.includes(value)).map(filteredStore => {
            newData.push(filteredStore)
        })
        this.setState({
            shopSearch: newData
        })
    }

    onChange = (value) => {
        let data = this.state.data
        var newData = []
        if (value == 'all') {
            this.setState({
                shopSearch: data
            })
        } else {
            data.filter(data => data.saleAreaCd.includes(value)).map(filteredStore => {
                newData.push(filteredStore)
            })
            this.setState({
                shopSearch: newData
            })
        }
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({ closeDropdown: false });
                            this.setState({
                                searchText: selectedKeys[0],
                                searchedColumn: dataIndex,
                            });
                        }}
                    >
                        Filter
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select(), 100);
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    getColumnSearchProps2 = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({ closeDropdown: false });
                            this.setState({
                                searchText: selectedKeys[0],
                                searchedColumn: dataIndex,
                            });
                        }}
                    >
                        Filter
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select(), 100);
            }
        },
    });

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    };

    handleChange = (pagination, filters, sorter) => {
        this.setState({
            filteredInfo: filters,
            sortedInfo: sorter,
            current: pagination.current,
            pageSize: pagination.pageSize
        });
    };
    render() {

        var current = this.state.current
        var pageSize = this.state.pageSize

        var lat_lon = {
            lat: this.state.lat,
            lng: this.state.lng
        }
        var columns = ([
            {
                title: 'ลำดับ',
                align: 'center',
                width: '5%',
                key: 'no',
                render: (text, record, index) => {
                    return (((current - 1) * pageSize) + index + 1)
                },
            },
            {
                title: 'ชื่อผู้รับผิดชอบ',
                key: 'firstName_th',
                // width: '10%',
                dataIndex: ['firstName_th', 'lastName_th'],

                render: (text, record) => (
                    <Space size="small">
                        {record.firstName_th}{record.lastName_th}
                    </Space>
                ),
                ...this.getColumnSearchProps2('firstName_th'),
            },
            {
                title: 'ชื่อเขต',
                dataIndex: ['saleAreaDesc'],
                key: 'saleAreaDesc',
                // width: '16%',
                // render: (text, record) => (
                //     <Space size="small">
                //         {record.email}
                //     </Space>
                // ),
                // ellipsis: true,
                ...this.getColumnSearchProps2('saleAreaDesc'),
            }, {
                title: 'อำเภอ',
                dataIndex: ['amphur'],
                key: 'amphur',

                ...this.getColumnSearchProps2('amphur'),
            },
            {
                title: 'จังหวัด',
                key: 'province',
                dataIndex: 'province',
                // width: '10%',
                ...this.getColumnSearchProps2('province'),
            },
            {
                title: 'วัน - เวลา',
                key: 'log_at',
                dataIndex: 'log_at',
                // width: '10%',
                ...this.getColumnSearchProps2('log_at'),
            }
        ])

        return (
            <>
                <h2>Location view</h2>

                {/* <div onClick={this.dd}>ddddddd</div> */}

                <Row gutter={[0, 0]}>
                    <Col span={12}>
                        <div style={{ height: '500px' }}>
                            {/* {this.state.data.length > 0 && <MapContainer data={this.state.data}/>} */}

                            {lat_lon &&
                                <Map
                                    google={google}
                                    zoom={10}
                                    style={mapStyles}
                                    center={lat_lon}
                                    disableDefaultUI
                                    zoomControl
                                >
                                    {this.state.datasaleclick.length > 0 ? this.showMarkersclick() : this.state.datasale.length > 0 && this.showMarkers()}


                                    <InfoWindow
                                        marker={this.state.activeMarker}
                                        onClose={this.onInfoWindowClose}
                                        visible={this.state.showingInfoWindow}>
                                        {this.state.activeMarker &&
                                            <div>
                                                <h1>{this.state.activeMarker.valuename}</h1>
                                                <p>{this.state.activeMarker.valuesaleAreaDesc}</p>
                                                <p>{this.state.activeMarker.valueprovince}</p>
                                                <p>{this.state.activeMarker.valuedate}</p>
                                            </div>
                                        }

                                    </InfoWindow>
                                </Map>
                            }



                        </div>
                    </Col>
                    <Col span={12} style={{ padding: '0px 15px 0px 15px' }}>
                        {/* <Select
                            showSearch
                            // style={{ width: 200 }}
                            style={{ width: '100%', marginBottom: '5px' }}
                            placeholder="เลือกเขตการขาย"
                            optionFilterProp="children"
                            onChange={this.onChange}
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                            onSearch={this.onSearch}
                            filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            <Option value="all" selected>ทั้งหมด</Option>
                            {result.map((op, index) =>
                                <Option key={index} value={op.saleAreaCd}>{op.saleAreaDesc}</Option>
                            )}
                        </Select>
                        <Input.Search allowClear
                            size='middle'
                            style={{ width: '100%', marginBottom: '15px', padding: '0 auto' }}
                            placeholder="ค้นหาร้านค้า"
                            onChange={this.temp_shop}
                        /> */}

                        <Table
                            className="myTable"
                            rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' : 'table-row-dark'}
                            columns={columns}
                            dataSource={this.state.datasale}
                            // onChange={this.handleChange}
                            // scroll={{ x: 1500, y: 300 }}
                            scroll={{ x: 1110, y: '100%' }}
                            size="small"
                            rowKey="empCd"
                            bordered
                            onRow={(record, rowIndex) => {
                                return {
                                    onClick: () => {
                                        if(record.lat){
                                            this.setState({
                                                datasaleclick: [record],
                                                activeMarker: null,
                                                showingInfoWindow: false,
                                                lat: record.lat,
                                                lng: record.lon
    
                                            });
                                        } else {
                                            message.info('ไม่พบข้อมูล')
                                            this.setState({
                                                datasaleclick: this.state.datasale,
                                                activeMarker: null,
                                                showingInfoWindow: false,
                                                lat: 13.7278956,
                                                lng: 100.5241235
    
                                            });
                                        }

                                    }, // click row
                                }
                            }}
                        />

                    </Col>
                </Row>

                {/* </div> */}
            </>
        )
        // } else {
        //     return (
        //         <>
        //             loading
        //         </>
        //     )
        // }
    }
}

export default ViewLocation;
